import { Box, Stack, Typography } from "@mui/material";
import Logo from "./image.png";
import { FoundryInfo } from "../FoundryInfo";

const CompanyInfo = ({ number, locationId }) => (
  <Stack justifyContent="space-between" direction="row">
    <Stack width="40%">
      <FoundryInfo logoHeight={50} locationId={locationId} showLogo />
    </Stack>
    <Stack width="40%" justifyContent="center" alignItems="end" gap="5px">
      <Typography variant="h3">Packing Slip</Typography>
      <Stack direction="row" gap="5px" alignItems="center">
        <Typography variant="body2">Number:</Typography>
        <Box border="1px solid grey" width="100px" textAlign="end" p="2px">
          <Typography
            variant="body2"
            backgroundColor="hubColors.yellowMainTransparent"
            color="hubColors.redMain"
          >
            {number}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  </Stack>
);

export default CompanyInfo;
